import { A4uSettings as IconComponent } from '@adobe/react-spectrum-workflow/dist/Settings.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Settings(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}